function ArrayPresenter(props) {
  return props.values.map((value, index) => <div key={index}>{value}</div>);
}

export default ArrayPresenter;
